import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import RedirectsEditFormModal from '../components/RedirectsEditFormModal';
import useMutation from '../../modules/react/hooks/useMutation';

export const UPLOAD_REDIRECTS = gql`
  mutation RedirectsEditRedirectsUpload($file: Upload!) {
    redirectsUpload(file: $file) {
      redirects {
        hostname
        source
        target
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  onUpload: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

const defaultProps = {};

const RedirectsEditModal = ({
  show,
  onDismiss,
  onUpload,
  ...rest
}) => {
  const [submitted, setSubmitted] = useState(false);
  const [submitErrors, setSubmitErrors] = useState(null);
  const [uploadRedirects, { data, loading, error }] = useMutation(UPLOAD_REDIRECTS);

  const onSubmit = ({ file }) => (
    uploadRedirects({ variables: { file } })
  );

  useEffect(() => {
    if (data) {
      const { redirects: updatedRedirects, userErrors } = data.redirectsUpload;

      if (updatedRedirects) {
        setSubmitted(true);
        onUpload(updatedRedirects);
      }

      if (userErrors.length > 0) {
        setSubmitErrors(userErrors);
        setSubmitted(false);
      }
    }

    if (error) {
      let message = '';
      error.graphQLErrors.forEach((gqlError) => {
        message += `${gqlError.message}\r\n`;
      });

      const err = { code: 0, message: message || 'Could not update redirects.' };

      setSubmitErrors(submitErrors ? [err, ...submitErrors] : [err]);
      setSubmitted(false);
    }
  }, [data, loading, error]);

  return (
    <RedirectsEditFormModal
      {...rest}
      show={show}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      submitted={submitted}
      submitting={loading}
      submitErrors={submitErrors}
    />
  );
};


RedirectsEditModal.propTypes = propTypes;
RedirectsEditModal.defaultProps = defaultProps;

export default RedirectsEditModal;
